'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

/**
 * Component that scrolls to the top of the page on route change.
 * This fixes the issue where navigating via Link components doesn't reset scroll position.
 */
export const ScrollToTop = () => {
  const pathname = usePathname();

  useEffect(() => {
    const target = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;
    if (target) {
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname]);

  return null;
};
